import { render, staticRenderFns } from "./SecretView.vue?vue&type=template&id=2b3d64dd"
import script from "./SecretView.vue?vue&type=script&lang=js"
export * from "./SecretView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports